export default __webpack_public_path__ + "static/media/cwdhcj.978b7829.png";